require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wsldsnetworkingeventreport.json") })
        }
      }, "path---wsldsnetworkingeventreport");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wsldsnetworkingeventreport!./.cache/json/wsldsnetworkingeventreport.json
// module id = 1278
// module chunks = 231608221292675